import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

const StyledPaper = styled(Paper)(() => ({
  backgroundColor: "#fff",
  maxWidth: 650,
  width: 650,
  borderRadius: 0,
  marginTop: 700,
  // minWidth:400,
  // minHeight: 'calc(100vh - 2px)'
}));

export default function LoginPage(props: any) {
  const jsonFile = useSelector((state: any) => state.style);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <div className="row login">
        <Box
          className="bodyForms-ex BodyFormVerify"
          sx={{
            my: 1,
            mx: "auto",
            // p: 3,
            borderRadius: "10px",
            overflow: "hidden",
            // paddingRight: 7,
            // paddingLeft: 7,
            // minHeight: "78vh",
            // borderLeft: "4px solid lightgray !important",
            // height: "85%",
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2)",
          }}
        >
          <Grid
            container
            wrap="nowrap"
            spacing={2}
            justifyContent="center"
            style={{ marginBottom: "8vh" }}
            sx={{ minWidth: { lg: "600px" } }}
          >
            {/* {(props.api == undefined || props.api.isCalled === false) && ( */}
            <Grid item xs>
              {props.childForm}
              {jsonFile?.loginTitle ? (
                <div
                  style={{
                    marginBottom: "5vh",
                    padding: "8px",
                    maxWidth: "427px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  className="iranSansFaNum textCenter colorTitle textFont14 "
                  dangerouslySetInnerHTML={{ __html: jsonFile.loginTitle }}
                ></div>
              ) : (
                ""
              )}
              {/* <Typography
              className="iranSansMedium textCenter colorTitle textFont12 fontSize "
              style={{ marginTop: "12vh" }}
            >
              با ورود و یا ثبت نام در
              <span className="colorOk"> "لیزینگ گلرنگ" </span> شما
              <span style={{ textDecoration: "underline" }}>
                {" "}
                شرایط و قوانین{" "}
              </span>
              استفاده از سرویس‌های سایت و
              <span style={{ textDecoration: "underline" }}>
                قوانین حریم خصوصی{" "}
              </span>
              آن را می‌پذیرید
            </Typography> */}
            </Grid>
            {/* )} */}
          </Grid>
        </Box>
      </div>
    </div>
  );
}
